/**
 * @module number.helpers
 */

/**
 * Returns a float truncated to a given number of fractional digits.
 */
export const truncToFixed = (value: number, digits: number): number => {
  const shift = 10 ** digits;
  return Math.trunc(value * shift) / shift;
};

export type NumberInput = string | number;

/**
 * Partial application function that truncates an input if its is a valid number,
 * otherwise returns input unchanged.
 *
 * Useful in a controlled input that constrains the fractional digits.
 *
 * @param inputValue  from an input field
 * @param digits  number of fractional digits
 */
export const truncateNumberInput =
  (digits = 1) =>
  (inputValue: NumberInput): NumberInput => {
    const numberValue = Number(inputValue);

    if (inputValue === "" || !Number.isFinite(numberValue)) {
      return inputValue;
    }

    return truncToFixed(numberValue, digits);
  };
